import React, { Component } from 'react';
import axios from 'axios';
import Switch from "react-switch";

import LoadSpinner from '../shared/loadSpinner';
import ToggleBtn from '../shared/toggleBtn';

import moment from 'moment';
moment.suppressDeprecationWarnings = true;
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from 'react-table';
import "react-table/react-table.css";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css';

import { Scatter } from 'react-chartjs-2';

/* Chart Items */
const randomColor = require('randomcolor');
const options = {
    maintainAspectRatio: false,
    scales: { 
        yAxes: [{ type: 'time', time: { unit: 'day' }, ticks: { fontColor: 'white' }, gridLines: { color: "rgba(200,200,200,0.2)" } }],
        xAxes: [{ ticks: { fontColor: 'white', max: 2400 }, gridLines: { color: "rgba(200,200,200,0.2)" } }]
    },
    legend: {
        labels: {
            filter: function(item, chart) { return !item.text.includes('Schedule'); },
            fontColor: 'white',
            padding: 20
        }
    }
}

/* Images */
import baseImg from '../../assets/astro1.jpg';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

function processData(data, type){
    var ret = "";
    try {
        if(type === "date"){
            var d = new Date(data);
            ret = (d.getMonth()+1) + "-" + d.getDate() + "-" + d.getFullYear() + " " + d.getHours() + ":" + (d.getMinutes() < 10 ? "0"+d.getMinutes() : d.getMinutes());
        }
        else if(type === "duration"){
            //Get hours from milliseconds
            var hours = data / (1000 * 60 * 60);
            var absoluteHours = Math.floor(hours);
            var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

            //Get remainder from hours and convert to minutes
            var minutes = (hours - absoluteHours) * 60;
            var absoluteMinutes = Math.floor(minutes);
            var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

            //Get remainder from minutes and convert to seconds
            var seconds = (minutes - absoluteMinutes) * 60;
            var absoluteSeconds = Math.floor(seconds);
            var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

            ret = h + ':' + m + ':' + s;
        }
        else if(type === "name"){
            data.toUpperCase().split(" ").forEach(function(nm){ if(nm.length > 0) { ret = ret + nm[0]; } });
        }
    }
    catch(ex){
        console.log("[Error] Processing Data: ",ex);
    }
    return ret;
}


class Astro extends Component{
    constructor(props) {
        super(props);
        this.state = {
            startTime:null, endTime:null,
            displayChart: false, displayEyeSel: false,
            loading: false, camCount:1,
            type:"daily", dataDisplay:0,
            selFilter:{}, clearEyeList:{},
            filters:[], chartData:[],
            chartCol:[], dataList:[],
            eyeList:{"set":[], "unset":[]}, 
            locationList:[], chartDisplayData: { labels:[], datasets:[] },
            selectedData:[], editAddress:false,
            selectedEye:{ 
                _id:null, name:"", url:"", motionFlg:false, recordFlg:false, type: "smarteye",
                active: false, facialFlg:false, objectFlg:false, tagFlg: false,
                dynamic:false, emptyHouse:false, travelToHouse:false, fullHouse:false,         
                locationId:null, location:{"address":"", "city":"", "state":"","zip":""},
                schedule:false, startTime:"00:00", endTime: "00:00"       
            },
            selectedView: null, viewDisplayTags: false,
            selAccessor: null, astroConnStatus:{}
        }
        // Data Cols
        this.selectedDataCol = [
            { Header: 'Camera ID', accessor: 'devName' },
            { 
                Header: 'Start Date', 
                accessor: 'startTime',
                Cell: row => {
                    return <span>{processData(row.row.startTime, "date")}</span>;
                }
            },
            { 
                Header: 'Duration', 
                accessor: 'duration',
                Cell: row => {
                    return <span>{processData(row.row.duration, "duration")}</span>;
                }
            },
            { 
                Header: 'Video Tag', 
                accessor: 'tagList', 
                Cell: row => { 
                    return <div className="tag-list">{row.row.tagList.map((item,i) => <div className={"tag " + item.type} key={i}>{processData(item.name, "name")}</div>) }</div>;
                }
            },
            { 
                Header: 'Controls', 
                accessor: 'videoLoc',
                Cell: row => {
                    return <div className="view-btn-container">
                        {(row.row.videoLoc !== '') && <div className="view-btn see" onClick={() => this.setViewVideo(row.row.videoLoc, row.row._original)}><i className="fas fa-binoculars"/></div> }
                        <div className="view-btn remove" onClick={() => this.deleteEyeData(row.row._original._id)}><i className="fas fa-dumpster" /></div>
                        <Switch className="view-clr-switch" id={row.row._original._id} checked={row.row._original._id in this.state.clearEyeList} onChange={this.handleClearSwitchChange} height={20} onColor={"#fa3264"} uncheckedIcon={<i className="fas fa-trash-alt" style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, paddingRight: 2}}/>} checkedIcon={<i className="far fa-trash-alt" style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, paddingRight: 2}}/>}/>                        
                    </div>;
                }
            }
        ];
        // References
        this.startDtRef = React.createRef();
        this.endDtRef = React.createRef();
        this.typeRef = React.createRef();
        this.filterRef = React.createRef();
        this.eyeRef = React.createRef();
        this.addressRef = React.createRef();

        this.getLocAddress = this.getLocAddress.bind(this);
        this.moveCtrl = this.moveCtrl.bind(this);
        this.setDate = this.setDate.bind(this);
        this.clickRef = this.clickRef.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.retrieveData = this.retrieveData.bind(this);
        this.selectDataList = this.selectDataList.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.handleClearSwitchChange = this.handleClearSwitchChange.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleTagChange = this.handleTagChange.bind(this);
        this.addNewTag = this.addNewTag.bind(this);
        this.removeCustomTag = this.removeCustomTag.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.selAddress = this.selAddress.bind(this);
        this.getSelectHeight = this.getSelectHeight.bind(this);
        this.selectEye = this.selectEye.bind(this);
        this.closeSelectEye = this.closeSelectEye.bind(this);
        this.saveEye = this.saveEye.bind(this);
        this.toggleEyeSelect = this.toggleEyeSelect.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.loadEyes = this.loadEyes.bind(this);
        this.setViewVideo = this.setViewVideo.bind(this);
        this.deleteEyeData = this.deleteEyeData.bind(this);
        this.deleteEyeDataList = this.deleteEyeDataList.bind(this);
        this.getConnStatus = this.getConnStatus.bind(this);
        this.getConnStatusText = this.getConnStatusText.bind(this);
        this.formatTime = this.formatTime.bind(this);
        this.formatChartData = this.formatChartData.bind(this);
        this.toggleDisplayData = this.toggleDisplayData.bind(this);
    }

    getLocAddress(){
        var ret = "";
        try {
            if(this.state.selectedEye.location && "address" in this.state.selectedEye.location && this.state.selectedEye.location.address.length > 0) { ret = ret + this.state.selectedEye.location.address+", "; }
            if(this.state.selectedEye.location && "city" in this.state.selectedEye.location && this.state.selectedEye.location.city.length > 0) { ret = ret+ this.state.selectedEye.location.city+", " }
            if(this.state.selectedEye.location && "state" in this.state.selectedEye.location && this.state.selectedEye.location.state.length > 0) { ret = ret+ this.state.selectedEye.location.state+" " }
            if(this.state.selectedEye.location && "zip" in this.state.selectedEye.location && this.state.selectedEye.location.zip.length > 0) { ret = ret+ this.state.selectedEye.location.zip; }
        }
        catch(ex){
            console.log("[Error] getting location address: ",ex);
        }
        return ret;
    }

    moveCtrl(dir, ref, scrollInt){
        try {  
            if(ref && ref.current) {
                var tmpPos = ref.current.scrollLeft + (scrollInt * dir);
                ref.current.scrollLeft = tmpPos;     
            }           
        }
        catch(ex){
            console.log("[Error] Moving Direction: ",ex);
        }
    }

    setDate(name, date){
        var self = this;
        try {
            this.setState({ [name]: date },() =>{ self.refreshData(); });
        }
        catch(ex){
            console.log(" [Error] Setting Date: ",ex);
        }
    }

    clickRef(refName){
        try {
            this[refName].current.setFocus();
        }
        catch(ex){
            console.log(" [Error] Selecting Reference: ",ex);
        }
    }

    handleChange(e){
        var self = this;
        try {
            var name = e.target.name;
            var value = e.target.value;

            this.setState({ [name]: value }, () =>{
                self.refreshData();
            });
        }
        catch(ex){
            console.log(" [Error] Handling Change: ",ex);
        }
    }

    refreshData(){
        try {
            if(this.state.startTime !== null && this.state.endTime !== null){
                this.retrieveData();
            }
        }
        catch(ex){
            console.log(" [Error] Refreshing Data: ",ex);
        }
    }

    retrieveData(){
        var self = this;
        try {            
            var user = this.props.checkUser(false,false);

            this.setState({ loading: true, displayChart: false }, () => {
                var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };
                var postData = { 
                    "start":this.state.startTime, "end":this.state.endTime,
                    "type":this.state.type,"filters":Object.keys(this.state.selFilter)};
                

                axios.post(self.props.baseUrl + "/astro/dataPt/getByDate", postData, { headers: getHeaders})
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Retrieving Results: ",ex);
                        self.setState({ loading: false });
                    }
                    else {
                        var dataRet = response.data.results;
                        
                        // generate column data
                        for(var i =0; i < dataRet.chartCol.length; i++){
                            if(dataRet.chartCol[i].Header !== ""){
                                dataRet.chartCol[i].columns = dataRet.chartCol[i].columns.map(function(item){
                                    return { ...item, 
                                        Cell: row => { 
                                            return (row.row[item.accessor] ? <div className="data-pt-btn" onClick={()=> self.selectDataList(row.row.devName, item.accessor, true)}>{row.row[item.accessor].total}</div> : <span/>);
                                        }};
                                });
                            }
                        }
        
                        self.setState({displayChart: (dataRet.dataList && dataRet.dataList.length > 0), loading: false,  
                            selectedData:[], selectedView: null, viewDisplayTags: false, clearEyeList: {},
                            chartCol:(dataRet.chartCol != null ? dataRet.chartCol : []),
                            chartData:(dataRet.chartData !== null ? dataRet.chartData : []),
                            dataList:(dataRet.dataList !== null ? dataRet.dataList : []),
                            filters:(dataRet.filterList !== null ? dataRet.filterList : []),
                            camCount: (dataRet.chartData !== null ? dataRet.chartData.length : 1) }, ()=> {
                                if(self.state.selAccessor !== null){
                                    self.selectDataList(self.state.selAccessor.dev, self.state.selAccessor.accessor, false);
                                }
                                if(self.state.dataDisplay === 1) { self.formatChartData(); }
                            });
                    }
                });    
            });                   
        }
        catch(ex){
            console.log(" [Error] retrieving data: ",ex);
        }
    }

    selectDataList(device, accessor, resetDisplay){
        try {
            var selData = this.state.dataList.filter(function(item){ return (item.accessor == accessor && item.devName == device); });
            
            var tmpSelAcc = (selData.length > 0 ? { dev: device, accessor: accessor } : null);
            this.setState({ dataDisplay: (resetDisplay ? 0 : this.state.dataDisplay), selectedData: selData, selectedView: null, viewDisplayTags:false, selAccessor: tmpSelAcc });
        }
        catch(ex){
            console.log(" [Error] selecting data: ",ex);
        }
    }

    handleSwitchChange(status, e, id){
        try {
           var tmpEye = this.state.selectedEye;           
           tmpEye[id] = status;

           tmpEye.tagFlg = (!tmpEye.objectFlg && !tmpEye.facialFlg ? false : tmpEye.tagFlg);

           if(id === "dynamic"){
                tmpEye.active = (tmpEye.dynamic ? false : tmpEye.active);
                tmpEye.dynamic = (tmpEye.active ? false : tmpEye.dynamic);                
           }
           else if(id === "active"){
                tmpEye.dynamic = (tmpEye.active ? false : tmpEye.dynamic);
                tmpEye.active = (tmpEye.dynamic ? false : tmpEye.active);
           }           

           this.setState({ selectedEye: tmpEye });
        }
        catch(ex){
            console.log("Error handling switch change data: ",ex);
        }
    }

    handleClearSwitchChange(status, e, id){
        try {
            var tmpList = this.state.clearEyeList;
            if(id in tmpList) {
                delete tmpList[id];
            }
            else {
                tmpList[id] = true;
            }

            this.setState({ clearEyeList: tmpList });
        }
        catch(ex){
            console.log("Error handling switch change data: ",ex);
        }
    }

    handleFormChange(e){
        try {
            var tmpEye = this.state.selectedEye;   
            var name = e.target.name;
            var value = e.target.value;
            tmpEye[name] = value;  

            this.setState({ selectedEye: tmpEye });            
        }
        catch(ex){
            console.log("Error handling form change data: ",ex);
        }
    }

    handleTagChange(e){
        try {
            var tmpView = this.state.selectedView;   
            var name = e.target.name;
            var value = e.target.value;
            tmpView[name] = value;  

            this.setState({ selectedView: tmpView });            
        }
        catch(ex){
            console.log("[Error] handling tag form change: ",ex);
        }
    }

    addNewTag(){
        var self = this;
        try {
            if(this.state.selectedView && this.state.selectedView.tagName){
                var tmpView = {...this.state.selectedView};

                if(tmpView.tagList.filter(function(tag){ return tag.name === self.state.selectedView.tagName; }).length <= 0){
                    var user = self.props.checkUser(false,true);
                    var tmpTag = { type: "custom", name: this.state.selectedView.tagName, value: -1 };

                    self.setState({ loading: true }, ()=> {
                        var postData = { "user": user, "dataPtId":this.state.selectedView._id, "updateType": "add", "tag": tmpTag };
                        axios.post(self.props.baseUrl + "/astro/dataPt/updateTag", postData, {'Content-Type': 'application/json'})
                            .then(function(response) {                                
                                if(response.data.error || !response.data.results){
                                    console.log(" [Error] Adding Video Tag: ", response.data.error);
                                    self.setState({ loading: false });
                                }
                                else {
                                    tmpView.tagList.push(tmpTag);
                                    tmpView.tagName = "";
                                    self.setState({ loading: false, selectedView: tmpView });
                                }
                            });   
                    });
                }
            }
        }
        catch(ex){
            console.log("[Error] adding new tag: ",ex);
        }
    }

    removeCustomTag(tagName){
        var self = this;
        try {
            if(this.state.selectedView){
                var tmpView = {...this.state.selectedView};

                var user = self.props.checkUser(false,true);
                    var tmpTag = { type: "custom", name: tagName, value: -1 };

                    self.setState({ loading: true }, ()=> {
                        var postData = { "user": user, "dataPtId":this.state.selectedView._id, "updateType": "remove", "tag": tmpTag };
                        axios.post(self.props.baseUrl + "/astro/dataPt/updateTag", postData, {'Content-Type': 'application/json'})
                            .then(function(response) {                                
                                if(response.data.error || !response.data.results){
                                    console.log(" [Error] Removing Video Tag: ", response.data.error);
                                    self.setState({ loading: false });
                                }
                                else {
                                    tmpView.tagList = tmpView.tagList.filter(function(tag){ return tag.name != tagName; });
                                    self.setState({ loading: false, selectedView: tmpView });
                                }
                            });   
                    });
            }
        }
        catch(ex){
            console.log("[Error] Removing custom tag: ",ex);
        }
    }

    handleAddressChange(e){
        var self = this;
        try {
            var tmpEye = this.state.selectedEye;   
           
            if(!tmpEye.location) { tmpEye.location = {"address":"", "city":"", "state":"","zip":""}; }
            tmpEye.location[e.target.name] = e.target.value;  

            if(tmpEye.location.address.length <= 0 && tmpEye.location.city.length <= 0
            && tmpEye.location.state.length <= 0 && tmpEye.location.zip.length <= 0) {
                tmpEye.locationId = null;
            }

            this.setState({ selectedEye: tmpEye }, ()=>{
                var user = self.props.checkUser(false,true);
                self.setState({ loading: true }, ()=> {
                    var postData = { "user": user, "searchtype":"address", "size": -1, "location": { "name": "", "address":tmpEye.location.address,"city":tmpEye.location.city, "state":tmpEye.location.state, "zip":tmpEye.location.zip } };
                    axios.post(self.props.baseUrl + "/fillmore/location/search", postData, {'Content-Type': 'application/json'})
                        .then(function(response) {
                            if(response.data.error || !response.data.results){
                                console.log(" [Error] Getting Location Search Results: ", response.data.error);
                                self.setState({ loading: false, locationList:[] });
                            }
                            else {
                                self.setState({ loading: false, locationList: response.data.results });
                            }
                        });   
                });
            });            
        }
        catch(ex){
            console.log("Error handling form change data: ",ex);
        }
    }

    selAddress(item){
        try {
            var tmpEye = this.state.selectedEye;

            tmpEye.locationId = item._id;
            tmpEye.location.address = item.address; 
            tmpEye.location.city = item.city;
            tmpEye.location.state = item.state; 
            tmpEye.location.zip = item.zip;             

            this.setState({ locationList: [], selectedEye: tmpEye, editAddress: false });
        }
        catch(ex){
            console.log("[Error] Setting Address: ",ex);
        }
    }

    getSelectHeight(){
        var ret = -500;
        try {
            if(this.eyeRef.current && this.eyeRef.current !== null){
                ret = (this.state.displayEyeSel ? 0 : (-1.0 * this.eyeRef.current.clientHeight));
            }
        }
        catch(ex){
            console.log("[Error] Getting Select Height: ",ex);
        }
        return ret;
    }

    selectEye(id, type){
        var self = this;
        try {
            if(id !== null){
                var tmpEye = this.state.eyeList[type].filter(function(item){ return item._id === id; });

                if(tmpEye.length > 0){
                    var eyeCopy = JSON.parse(JSON.stringify(tmpEye[0]));
                    // Format Time
                    eyeCopy.startTime = this.formatTime(eyeCopy.startTime);
                    eyeCopy.endTime = this.formatTime(eyeCopy.endTime);

                    if(!eyeCopy.location || Object.keys(eyeCopy.location).length < 1) { eyeCopy.location = {"address":"", "city":"", "state":"","zip":""}; }
                    this.setState({ selectedEye: eyeCopy },() =>{
                        self.getConnStatus((eyeCopy.type == "stream" ? "astroWatcher" : eyeCopy.url));
                    });
                }    
            }
            else {
                var tmpEye = { 
                    _id:"", name:"", url:"", motionFlg:false, recordFlg:false, type: "smarteye",
                    active: false, facialFlg:false, objectFlg:false, tagFlg: false,
                    dynamic:false, emptyHouse:false, travelToHouse:false, fullHouse:false,
                    locationId:null, location:{"address":"", "city":"", "state":"","zip":""},
                    schedule:false, startTime:"00:00", endTime: "00:00"
                };
                this.setState({ selectedEye: tmpEye });
            }                    
        }
        catch(ex){
            console.log("[Error] selecting eye: ",ex);
        }
    }

    closeSelectEye(){
        try {
            var tmpEye = this.state.selectedEye;
            tmpEye._id = null;
            
            this.setState({ selectedEye: tmpEye });
        }
        catch(ex){
            console.log("[Error] closing selecting eye: ",ex);
        }
    }

    saveEye(){
        var self = this;
        try {
            if(this.state.selectedEye._id !== null){
                var postData = { eye: this.state.selectedEye };
                postData.eye._id = (postData.eye._id === "" ? null : postData.eye._id);
                postData.eye.startTime = parseInt(postData.eye.startTime.split(":").join(""));
                postData.eye.endTime = parseInt(postData.eye.endTime.split(":").join(""));

                delete postData.eye.location;

                this.setState({ loading: true }, () => {
                    axios.post(self.props.baseUrl + "/astro/eye/update", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error){
                            console.log(" [Error] Updating Eye: ", response.data.error);
                        }
                        else {
                            console.log(" [Error] Eye wasn't updated ");
                            alert("Eye " + (response.data.results ? "was": "wasn't") + " updated");
                        }
                        
                        self.setState({ loading: false });
                        self.loadEyes();
                    });    
                });    
            }
        }
        catch(ex){
            console.log("[Error] saving eye: ",ex);
        }
    }

    toggleEyeSelect(){
        var self = this;
        try {
            this.setState({ displayEyeSel: !this.state.displayEyeSel });
        }
        catch(ex){
            console.log("[Error] toggle eye select: ",ex);
        }
    }

    toggleFilter(filter){
        var self = this;
        try {
            var tmpFilters = this.state.selFilter;
            if(filter in tmpFilters){
                delete tmpFilters[filter];
            }
            else {
                tmpFilters[filter] = true;
            }

            this.setState({ selFilter: tmpFilters }, () =>{ self.refreshData(); });
        }
        catch(ex){
            console.log("[Error] toggle filters: ",ex);
        }
    }

    loadEyes(){
        var self = this;
        try {
            axios.post(self.props.baseUrl + "/astro/eye/retrieve", {}, {'Content-Type': 'application/json'})
            .then(function(response) {
                if(response.data.error){
                    console.log(" [Error] Retrieving Eyes: ",response.data.error);
                }
                else {
                    var tmpData =  response.data.results;
                    tmpData.set.sort(function(a,b){
                        if (a.type < b.type) { return -1;}
                        if (a.type > b.type) { return 1; }
                        return 0;
                    });

                    self.setState({ eyeList: tmpData, selectedEye: { 
                        _id:null, name:"", url:"", motionFlg:false, recordFlg:false, type: "smarteye",
                        active: false, facialFlg:false, objectFlg:false, tagFlg: false,
                        dynamic:false, emptyHouse:false, travelToHouse:false, fullHouse:false,
                        locationId:null, location:{"address":"", "city":"", "state":"","zip":""},
                        schedule:false, startTime:"00:00", endTime: "00:00"   
                    }});
                }
            });
        }
        catch(ex){
            console.log("[Error] toggle eye select: ",ex);
        }
    }

    setViewVideo(video, selectedItem){
        try{
            //startTime
            if(video && video !== null){
                var tmpStr = video.split("/");
                this.setState({ viewDisplayTags:false, selectedView: { 
                    _id: selectedItem._id, name: processData(selectedItem.startTime, "date"), 
                    video: this.props.baseUrl +"/astro/stream/"+ tmpStr[0] + "?filename=" + tmpStr[1],
                    tagName:"", tagList: selectedItem.tagList
                } });
            }
        }
        catch(ex){
            console.log("[Error] setting view video: ",ex);
        }
    }

    deleteEyeData(id){
        var self = this;
        try{
            var firm = confirm("Do you want to remove this data point?");

            if(firm === true){
                var user = this.props.checkUser(false,true);
                this.setState({ loading: true }, () => {
                    var postData = { "user": user, "_id": id };

                    axios.post(self.props.baseUrl + "/astro/dataPt/remove", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error){
                            console.log(" [Error] Removing Eye Data: ", response.data.error);
                        }
                        else if(!response.data.results) {
                            console.log(" [Error] Eye data wasn't removed ");
                        }
                        self.refreshData();
                        self.setState({ loading: false });
                    });    
                });    
            }
        }
        catch(ex){
            console.log("[Error] Deleting eye data: ",ex);
        }
    }
    
    deleteEyeDataList(){
        var self = this;
        try {
            var firm = confirm("Do you want to remove the selected data points?");

            if(firm === true){
                var user = this.props.checkUser(false,true);
                var idList = Object.keys(this.state.clearEyeList);
                this.setState({ loading: true }, () => {
                    var postData = { "user": user, "idList": idList };

                    axios.post(self.props.baseUrl + "/astro/dataPt/removeList", postData, {'Content-Type': 'application/json'})
                    .then(function(response) {
                        if(response.data.error){
                            console.log(" [Error] Removing Eye Data List: ", response.data.error);
                        }
                        else if(!response.data.results) {
                            console.log(" [Error] Eye data list wasn't removed ");
                        }
                        self.refreshData();
                        self.setState({ loading: false });
                    });    
                });    
            }
        }
        catch(ex){
            console.log("[Error] Deleting eye data list: ",ex);
        }
    }

    getConnStatus(id){
        var self = this;
        try {
            var url = self.props.baseUrl + "/astro/connStatus/" + id;
            axios.get(url, {'Content-Type': 'application/json'})
                .then(function(response) {
                    if(response.data.error ){
                        console.log(" [Error] Getting Connection Status: ", response.data.error);
                    }
                    else {
                        var tmpConnStatus = self.state.astroConnStatus;
                        tmpConnStatus[id] = response.data.results;
                        
                        self.setState({ astroConnStatus: tmpConnStatus });
                    }
                });  
        }
        catch(ex){
            console.log("[Error] Getting Connection Status: ",ex);
        }
    }

    getConnStatusText(type, url, conType){
        var ret = "";
        try {
            var id = (type === "stream" ? "astroWatcher" : url);

            if(conType === "text"){
                if(!(id in this.state.astroConnStatus)){
                    ret = "No Active Connection"
                }
                else {
                    ret = (this.state.astroConnStatus[id].active ? "Astro Connection is Active" : "Non-Active Astro Connection");
                    if("date" in this.state.astroConnStatus[id]){
                        var d = new Date(this.state.astroConnStatus[id].date);
                        ret = ret + " [ Active Since: " + d.toDateString() + " " + d.toLocaleTimeString() + " ]";
                    }
                }
            }
            else {
                ret = (id in this.state.astroConnStatus && this.state.astroConnStatus[id].active == true)
            }
        }
        catch(ex){
            console.log("[Error] Getting Connection Status Text: ",ex);
        }

        return ret;
    }

    formatTime(time){
        var ret = "00:00";

        try {
            var tmpStr = time.toString();
            while(tmpStr.length < 4){
                tmpStr = "0" + tmpStr;
            }

            ret = tmpStr.substring(0,2) + ":" + tmpStr.substring(2);
        }
        catch(ex){
            console.log("[Error] Formatting Time: ",ex);
        }

        return ret;
    }

    formatChartData(){
        var self = this, chartData = { labels:[], datasets:[] };

        try {
            this.setState({ loading: true }, ()=> {                
                var colorList = randomColor({ luminosity: 'bright', format: 'rgb', count: self.state.chartData.length });
                
                var tmpSetHash = {}, tmpLabelHash = {}, colorUsed = 0;
                
                self.state.dataList.forEach(function(data){
                    // Update Label Hash
                    tmpLabelHash[data.accessor] = true;

                    // Get Time
                    var d = new Date(data.startTime);
                    var tmpTime = parseInt(d.getHours() + "" + d.getMinutes());

                    // Update Set Hash
                    if(data.devName in tmpSetHash){
                        tmpSetHash[data.devName].data.push({ x: tmpTime, y: moment(new Date(data.accessor)).format("YYYY-MM-DD") });
                    }
                    else {
                        tmpSetHash[data.devName] = {
                            "type":"scatter", "label":data.devName,
                            "backgroundColor": colorList[colorUsed],
                            "data":[{ x: tmpTime, y: moment(new Date(data.accessor)).format("YYYY-MM-DD") }]
                        }
                        colorUsed++;
                    }
                });

                chartData.labels = Object.keys(tmpLabelHash);
                chartData.datasets = Object.values(tmpSetHash);
                self.setState({ chartDisplayData: chartData, loading: false });
            });
        }
        catch(ex){
            console.log("[Error] Formating Chart Data: ",ex);
            self.setState({ chartDisplayData: chartData, loading: false });
        }
    }

    toggleDisplayData(val){
        var self = this;
        try {
            this.setState({ dataDisplay: val }, ()=> {
                if(val == 1) { self.formatChartData(); }
            });
        }
        catch(ex){
            console.log("[Error] Toggle Display Data: ",ex);
        }
    }

    componentWillUnmount() {}

    componentDidMount(){
        this.loadEyes();
    }

    render(){  
        return(
            <div className="page-container astro-page">
                {this.state.loading && <LoadSpinner userClass="astro" /> }
               <div className="btn-container">
                    <div className="tro-btn date-selector-btn">
                        <DatePicker selected={this.state.startTime} placeholderText="Start Date" ref={this.startDtRef} onChange={(date)=> this.setDate("startTime", date)} />
                        <div className="btn-icon" onClick={()=> this.clickRef("startDtRef")}><i className="far fa-calendar-alt" /></div>
                    </div>

                    <div className="tro-btn date-selector-btn">
                        <DatePicker selected={this.state.endTime} placeholderText="End Date" ref={this.endDtRef} onChange={(date)=> this.setDate("endTime", date)} />
                        <div className="btn-icon" onClick={()=> this.clickRef("endDtRef")}><i className="far fa-calendar-alt" /></div>
                    </div>

                    <div className="tro-btn select-btn">
                        <select name="type" value={this.state.type} onChange={this.handleChange}>
                            <option value="hourly">Hourly</option>
                            <option value="daily">Daily</option>
                            <option value="monthly">Monthly</option>
                        </select>
                        <div className="btn-icon unshifted"><i className="fas fa-clipboard-list" /></div>
                    </div>

                    {this.state.displayChart &&
                        <div className="tro-btn btn" onClick={this.refreshData}>
                            <div className="btn-txt">Refresh Data</div>
                            <div className="btn-icon"><i className="fas fa-sync-alt" /></div>
                        </div>
                    }

                    {Object.keys(this.state.clearEyeList).length > 0 &&
                        <div className="tro-btn btn btn-end" onClick={this.deleteEyeDataList}>
                            <div className="btn-txt">Remove Selected</div>
                            <div className="btn-icon c2"><i className="fas fa-trash-alt" /></div>
                        </div>
                    }
               </div>

               <div className="page-panel data-chart">
                    {this.state.displayChart ? 
                        <ReactTableFixedColumns data={this.state.chartData} columns={this.state.chartCol} defaultPageSize={this.state.camCount} showPagination={false} className="-striped"/>  :
                        <div className="no-data">No Data For Current Selection</div>
                    }
               </div>
                
               {this.state.filters.length > 0 &&
                    <div className="filter-scroll-container">
                        {Object.keys(this.state.selFilter).length > 0 &&
                            <div className="selected-filter-list">
                                {Object.keys(this.state.selFilter).map((item,i) =>
                                    <span key={i}>{(i > 0 ? "," : "")} {item}</span>
                                )}
                            </div>
                        }
                        <div className="page-panel filter-scroll-list">
                            <div className="filter-title">
                                <h2>Filters</h2>
                                <div className={"btn-row"}>
                                    <div className="ctrl-icon" onClick={() => this.moveCtrl(-1,this.filterRef, 360)}><i className="fas fa-chevron-left" /></div>
                                    <div className="ctrl-icon" onClick={() => this.moveCtrl(1,this.filterRef, 360)}><i className="fas fa-chevron-right" /></div>
                                </div> 
                            </div>                        
                            <div className="filter-list-container" ref={this.filterRef}>
                                {this.state.filters.map((item,i) => 
                                    <div className={"filter-btn" +(item in this.state.selFilter ? " sel":"")} key={i} onClick={()=> this.toggleFilter(item)}>
                                        <div className="filter-icon">{ processData(item, "name") }</div>
                                        <span>{item}</span>
                                    </div>
                                )}
                                <div className="end-btn"/>
                            </div>                        
                        </div>
                    </div>
                }
               
               {/* Display Toggle */}
               {(this.state.displayChart && this.state.type === "daily") &&
                    <div className="display-toggle-container">
                        <div className="display-toggle">
                            <div className={"toggle-title left" + (this.state.dataDisplay === 0 ? " sel":"")} onClick={() => this.toggleDisplayData(0)}><span>View</span></div>
                            <div className={"toggle-title right" + (this.state.dataDisplay === 1 ? " sel":"")} onClick={() => this.toggleDisplayData(1)}><span>Data</span></div>
                        </div>
                    </div>
               }

               {/* Data Chart Display */}
               {this.state.dataDisplay === 1 &&
                    <div className="chart-info">
                        <Scatter data={this.state.chartDisplayData} options={options} />
                    </div>
               }
               {/* View Display */}
               {this.state.dataDisplay === 0 &&
                    <div className="data-info">
                        <div className="page-panel video-panel">
                            {this.state.selectedView !== null &&
                                <div className={"video-title-container" + (this.state.viewDisplayTags ? " open" : "")}> 
                                    <div className="tag-ctrl">
                                        <div className="curTag-container">
                                            {this.state.selectedView.tagList.map((tag,i)=>
                                                <div className={"curTag " + tag.type} key={i}>
                                                    <span>{tag.name}</span>
                                                    {tag.value < 0 && <i className="fas fa-times" onClick={() => this.removeCustomTag(tag.name)}/> }
                                                </div>
                                            )}
                                        </div>

                                        <div className="btn-container">
                                            <div className="tro-btn date-selector-btn">
                                                <input value={this.state.selectedView.tagName} name="tagName" placeholder="Enter New Tag" autoComplete="off" onChange={this.handleTagChange} />
                                                <div className="btn-icon" onClick={this.addNewTag}><i className="fas fa-tag" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="close-video">
                                        <span>{this.state.selectedView.name}</span>
                                        <div className="btn-list">
                                            <i className="fas fa-tags" onClick={() => this.setState({ viewDisplayTags: !this.state.viewDisplayTags })}/>
                                            <i className="fas fa-times" onClick={() => this.setState({ selectedView: null })}/>
                                        </div>
                                    </div> 
                                </div>
                            }

                            {this.state.selectedView !== null ? 
                                <video key={this.state.selectedView.video} controls width="100%" height="100%">
                                    <source src={this.state.selectedView.video} type="video/mp4" />
                                    Sorry, your browser doesn't support embedded videos.
                                </video> :
                                <div className="view-img"><img src={baseImg} alt="astro view" /></div>
                            }
                        </div>
                        <div className="page-panel info-panel">
                            {(!this.state.selectedData || this.state.selectedData.length == 0 ?
                                <div className="no-data">No Data Selected</div> :
                                <ReactTable columns={this.selectedDataCol} data={this.state.selectedData} defaultPageSize={10} showPageSizeOptions={false} className="-striped"/>
                            )}
                        </div>
                    </div>
                }

                {/* Sliding Panel */}
               <div className={"eyes-container" + (this.state.displayEyeSel ? " open": "")} ref={this.eyeRef} style={{ bottom: this.getSelectHeight() }} >
                    <div className="eye-btn" onClick={this.toggleEyeSelect}><i className="far fa-eye" /></div>
                        
                    {this.state.selectedEye._id === null &&
                        <div className="eye-list-container">
                            <div className="eye-list">
                                <div className="list-item add" onClick={()=> this.selectEye(null, "set")}>
                                    <div className="item-icon"><i className="fas fa-plus" /></div>
                                    <span>Add Eye</span>
                                </div>

                                {this.state.eyeList.set.map((item,i) =>
                                    <div className="list-item" key={i} onClick={()=> this.selectEye(item._id, "set")}>
                                        <div className="item-icon"><i className={"fas " +(item.type === "smarteye" ? "fa-laptop-house" : "fa-wifi")} /></div>
                                        <span>{item.name}</span>
                                    </div>
                                )}

                                {this.state.eyeList.unset.map((item,i) =>
                                    <div className="list-item unset" key={i} onClick={()=> this.selectEye(item._id, "unset")}>
                                        <div className="item-icon"><i className="far fa-eye-slash" /></div>
                                        <span>{item.name}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    }

                    {this.state.selectedEye._id !== null &&
                        <div className="selected-eye">
                            {/* R0 */}
                            <div className="btn-container">
                                <div className="eye-status-container">
                                    {/* astroConnStatus */}
                                    <div className={"eye-status " +(this.getConnStatusText(this.state.selectedEye.type, this.state.selectedEye.url, "status") ? "active" : "not-active")} />
                                    <div className="eye-text">{this.getConnStatusText(this.state.selectedEye.type, this.state.selectedEye.url, "text")}</div>
                                </div>

                                <div className="tro-btn btn" onClick={this.saveEye}>
                                    <div className="btn-txt">Save</div>
                                    <div className="btn-icon"><i className="far fa-save" /></div>
                                </div>
                                <div className="tro-btn btn icon-btn" onClick={this.closeSelectEye}>
                                    <div className="btn-icon"><i className="fas fa-times" /></div>
                                </div>
                            </div>

                            {/*R1*/}
                            <div className="selected-eye-section input-container">
                                <div className="input-field sz-2">
                                    <span>Type</span>
                                    <ToggleBtn toggles={["smarteye","stream"]} selected={this.state.selectedEye.type} name="type" handleChange={this.handleFormChange}/>
                                </div>
                                <div className="input-field sz-3">
                                    <span>Device Name</span>
                                    <input type="text" name="name" autoComplete="off" value={this.state.selectedEye.name} onChange={this.handleFormChange} />
                                </div>
                                <div className="input-field sz-5">
                                    <span>Device Url</span>
                                    <input type="text" name="url" autoComplete="off" value={this.state.selectedEye.url} onChange={this.handleFormChange} />
                                </div>
                            </div>

                            {/*R2*/}
                            <div className="selected-eye-section input-container">
                                <div className="section-header">
                                    <div className="header-icon"><i className="fas fa-check"/></div>
                                </div>

                                <div className="input-field sz-2">
                                    <span>Active</span>    
                                    <Switch className="input-switch" id="active" checked={this.state.selectedEye.active} onChange={this.handleSwitchChange} height={20} />                        
                                </div>
                                <div className="input-field sz-2">
                                    <span>Motion</span>    
                                    <Switch className="input-switch" id="motionFlg" checked={this.state.selectedEye.motionFlg} onChange={this.handleSwitchChange} height={20} />                          
                                </div>
                                <div className="input-field sz-2">
                                    <span>Record</span>         
                                    <Switch className="input-switch" id="recordFlg" checked={this.state.selectedEye.recordFlg} onChange={this.handleSwitchChange} height={20} />                     
                                </div>
                                <div className="input-field sz-2">
                                    <span>Facial</span>       
                                    <Switch className="input-switch" id="facialFlg" checked={this.state.selectedEye.facialFlg} onChange={this.handleSwitchChange} height={20} />                       
                                </div>
                                <div className="input-field sz-2">
                                    <span>Object</span>   
                                    <Switch className="input-switch" id="objectFlg" checked={this.state.selectedEye.objectFlg} onChange={this.handleSwitchChange} height={20} />                           
                                </div>
                                
                                {/*<div className="input-field sz-2">
                                    <span>Tags Only</span>   
                                    <Switch className="input-switch" id="tagFlg" checked={this.state.selectedEye.tagFlg} onChange={this.handleSwitchChange} height={20} />                           
                                </div>*/}
                            </div>
                            
                            {/*R3*/}
                            <div className="selected-eye-section input-container">
                                <div className="section-header">
                                    <div className="header-icon"><i className="fas fa-clock"/></div>
                                </div>
                                <div className="input-field sz-2">
                                    <span>Schedule</span>
                                    <Switch className="input-switch" id="schedule" checked={this.state.selectedEye.schedule} onChange={this.handleSwitchChange} height={20} />                        
                                </div>
                                <div className="input-field sz-3">
                                    <span>Start Time</span>
                                    <input type="time" name="startTime" autoComplete="off" value={this.state.selectedEye.startTime} onChange={this.handleFormChange} />
                                </div>
                                <div className="input-field sz-3">
                                    <span>End Time</span>
                                    <input type="time" name="endTime" autoComplete="off" value={this.state.selectedEye.endTime} onChange={this.handleFormChange} />
                                </div>
                            </div>

                            {/*R4*/}
                            <div className="selected-eye-section input-container">
                                <div className="section-header">
                                    <div className="header-icon"><i className="fas fa-dice-d20"/></div>
                                </div>

                                <div className="input-field sz-2">
                                    <span>Dynamic Eye</span>    
                                    <Switch className="input-switch" id="dynamic" checked={this.state.selectedEye.dynamic} onChange={this.handleSwitchChange} height={20} />                        
                                </div>
                                <div className="input-field sz-2">
                                    <span>Empty House</span>   
                                    <Switch className="input-switch" id="emptyHouse" checked={this.state.selectedEye.emptyHouse} onChange={this.handleSwitchChange} height={20} />                           
                                </div>
                                <div className="input-field sz-2">
                                    <span>Traveling To House</span>   
                                    <Switch className="input-switch" id="travelToHouse" checked={this.state.selectedEye.travelToHouse} onChange={this.handleSwitchChange} height={20} />                           
                                </div>
                                <div className="input-field sz-2">
                                    <span>Full House</span>   
                                    <Switch className="input-switch" id="fullHouse" checked={this.state.selectedEye.fullHouse} onChange={this.handleSwitchChange} height={20} />                           
                                </div>

                                <div className={"input-field dynamic-field " + (this.state.editAddress ? "sz-10" : "sz-6")}>
                                    <div className="icon-btn" onClick={()=> this.setState({ editAddress: !this.state.editAddress })}><i className={"fas " + (!this.state.editAddress ? "fa-map-marked-alt" : "fa-times")} /></div>
                                    {!this.state.editAddress &&
                                        <div className="address-section input-container">
                                            <div className="input-field sz-10">
                                                <span>Location</span>
                                                <input type="text" disabled="disabled" value={this.getLocAddress()} />
                                            </div>
                                        </div>
                                    }

                                    {this.state.editAddress && 
                                        <div className="address-section input-container">
                                            <div className="input-field sz-4">
                                                <span>Address</span>
                                                <input type="text" name="address" value={this.state.selectedEye.location.address} onChange={this.handleAddressChange} autoComplete="off" />
                                            </div>
                                            <div className="input-field sz-2">
                                                <span>City</span>
                                                <input type="text" name="city" value={this.state.selectedEye.location.city} onChange={this.handleAddressChange} autoComplete="off" />
                                            </div>
                                            <div className="input-field sz-2">
                                                <span>State</span>
                                                <input type="text" name="state" value={this.state.selectedEye.location.state} onChange={this.handleAddressChange} autoComplete="off" />
                                            </div>
                                            <div className="input-field sz-2">
                                                <span>Zip</span>
                                                <input type="text" name="zip" value={this.state.selectedEye.location.zip} onChange={this.handleAddressChange} autoComplete="off" />
                                            </div>
                                        </div>
                                    }

                                    {/* locationList */}
                                    {this.state.editAddress &&
                                        <div className="address-search">
                                            <div className="sel-ctrl left" onClick={() => this.moveCtrl(-1,this.addressRef, 360)}><i className="fas fa-angle-left" /></div>
                                            <div className="sel-group-container" ref={this.addressRef}>
                                                {this.state.locationList.map((item,i) =>
                                                    <div className="sel-item" key={i} onClick={()=> this.selAddress(item)}>
                                                        <div className="item-row">{item.address}</div>
                                                        <div className="item-row">{item.city}, {item.state} {item.zip}</div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="sel-ctrl right" onClick={() => this.moveCtrl(1,this.addressRef, 360)}><i className="fas fa-angle-right" /></div>
                                        </div>
                                    }
                                </div>
                            </div>                           
                        </div>
                    }
               </div>
            </div>
        );
    }
}

export default Astro;